import { useRecoilValue } from "recoil";
import Header from "../../../components/header";
import { insetState } from "../../../recoil/inset";
import WalletPageTab from "./components/page-tab";
import { WalletTab } from "./hooks/use-wallet-tab";
import { WalletWrapper, WalletInnerWrapper } from "./style";
import WalletPub from "./components/pub";
import { useWalletContext } from "./hooks/wallet-context";
import WalletLogs from "./components/log";
import { WalletLogProvider } from "./hooks/wallet-log-context";
import WalletHistory from "./components/history";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { enqueueSnackbar } from "notistack";
import { LOCAL_STORAGE_ACCESS_KEY } from "../../../utils/network";
import FranchisePubPopup from "./components/pub/components/franchise-pub";
import Order from "./components/order";

const Wallet = () => {
  const { isWalletTab, isFranchisePubOpen } = useWalletContext();
  const inset = useRecoilValue(insetState);
  const history = useHistory();

  useEffect(() => {
    const accessToken = localStorage.getItem(LOCAL_STORAGE_ACCESS_KEY);
    if (!accessToken) {
      history.push("/login");
      enqueueSnackbar("로그인이 필요한 페이지입니다. ", {
        variant: "error",
      });
    }
  }, []);

  return (
    <WalletWrapper>
      <Header title="MY PUB" />
      <WalletInnerWrapper inset={inset}>
        {(isWalletTab(WalletTab.WALLET) || isWalletTab(WalletTab.HISTORY)) && (
          <WalletPageTab />
        )}
        {isWalletTab(WalletTab.WALLET) && <WalletPub />}
        {isWalletTab(WalletTab.LOGS) && (
          <WalletLogProvider>
            <WalletLogs />
          </WalletLogProvider>
        )}
        {isWalletTab(WalletTab.HISTORY) && <WalletHistory />}
        {isWalletTab(WalletTab.ORDER) && <Order />}
        {isFranchisePubOpen && <FranchisePubPopup />}
      </WalletInnerWrapper>
    </WalletWrapper>
  );
};

export default Wallet;
